import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "quickfinder" }
const _hoisted_2 = { class: "row gx-0" }
const _hoisted_3 = { class: "col-xl-4 d-xl-block d-none" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "col-xl-8" }
const _hoisted_6 = ["action"]
const _hoisted_7 = { class: "quickfinder__body" }
const _hoisted_8 = { class: "quickfinder__row-item d-flex align-items-center" }
const _hoisted_9 = { class: "d-inline-block me-4" }
const _hoisted_10 = { class: "quickfinder__row-item d-flex align-items-center" }
const _hoisted_11 = { class: "d-inline-block me-4" }
const _hoisted_12 = {
  key: 0,
  class: "quickfinder__row-item quickfinder__row-item--nowrap d-flex gap-4 align-items-center flex-wrap"
}
const _hoisted_13 = { class: "d-flex gap-3" }
const _hoisted_14 = { class: "d-flex flex-nowrap gap-4 align-items-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "quickfinder__row-item d-flex gap-4 align-items-center"
}
const _hoisted_17 = { class: "quickfinder__row-item" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "quickfinder__price" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-bag btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_22 = ["href"]

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import Datepicker from "./components/form-elements/Datepicker.vue";
import Select from "./components/form-elements/Select.vue";
import {fetcher} from "../utils/utils.ts";
import {trackEvent} from "../utils/tracking.ts";
import Radio from "./components/form-elements/Radio.vue";
// @ts-ignore
import * as lazyImg from "@elements/lazy-img";
// @ts-ignore
import { ISOStringToDate, dateToISOString } from "@elements/date-utils";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import Price from "./components/Price.vue";
// @ts-ignore
import { translate } from "@elements/translations";
import Toast from "./components/Toast.vue";
import CustomSelect from "./components/form-elements/CustomSelect.vue";
// @ts-ignore
import {assert, object, number, string, array, optional, boolean} from 'superstruct'


export default /*#__PURE__*/_defineComponent({
  __name: 'Quickfinder',
  props: {
    img: {},
    url: {},
    formAction: {},
    overviewUrl: {}
  },
  setup(__props: any) {

const props = __props;



const ticketCategoriesOptions = ref<String[]>([]);
const personsOptions = ref<String[]>([]);
const showDate = ref(true);
const disabledDates = ref(["2023-09-21"]);
const minDate = ref("");
const maxDate = ref("");
const loading = ref(false);
const datePlaceholderString = ref('nächste Saison');
const date = ref<Date>();
const radioToday = ref(true);
const radioTomorrow = ref(false);
const price = ref(0);
const selectedOption = ref('');
const errors = ref([]);
const submitUrl = ref(props.formAction);
//only for removing this parameter from the url if datepicker is empty
const datepickerDisabled = ref(false);
const hideQuickfinder = ref(false);
const ticketCategory = ref<String>('undefined');

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);

// Fetch data from JSON file
onMounted(async () => {
    try {
        await fetchInitialData();

    } catch (error) {
        console.error('Error fetching data: ', error);
        errors.value.push(error)
    }
    await nextTick(lazyImg.init());
});

let QuickfinderResult = object({
  categories: array(object({
    id: string(),
    value: string(),
    label: string(),
    submitUrl: string()
  })),
  persons: array(object({
    value: string(),
    label: string(),
    price: number(),
  })),
  showDate: boolean(),
  datePlaceholderString: optional(string()),
  disabledDates: optional(array(string())),
  minDate: optional(string()),
  maxDate: optional(string()),
});

const fetchInitialData = async () => {
    loading.value = true;

    await fetcher(props.url).then((result) => {

      try {
        assert(result, QuickfinderResult);

        ticketCategoriesOptions.value = result.categories.map((type) => {
          return {
            id: type.id,
            value: type.value,
            label: type.label,
            submitUrl: type.submitUrl
          }
        });

        personsOptions.value = result.persons.map((type) => {
          return {
            value: type.value,
            label: type.label,
            price: type.price
          }
        });

        price.value = personsOptions.value[0].price;
        selectedOption.value = personsOptions.value[0].value;

        showDate.value = result.showDate;
        datePlaceholderString.value = result.datePlaceholderString;
        disabledDates.value = result.disabledDates;
        minDate.value = result.minDate;
        maxDate.value = result.maxDate;
        loading.value = false;
      } catch (error: unknown) {
        console.log(error);
        errors.value.push(error.message);
      }

    }).catch((error) => {
        console.log(error);
        errors.value.push(error)
    });

}

const changeTicketCategory = async (value) => {
    loading.value = true;
    ticketCategory.value = value;

    //change submitUrl to the one from the selected category
    submitUrl.value = ticketCategoriesOptions.value.find((category) => category.value === value).submitUrl;

    const separator = props.url.includes('?') ? '&' : '?';
    await fetcher(props.url + separator + 'category=' + value).then((result) => {

      try {
        assert(result, QuickfinderResult);

        personsOptions.value = result.persons.map((type) => {
          return {
            value: type.value,
            label: type.label,
            price: type.price
          }
        });

        price.value = personsOptions.value[0].price;
        selectedOption.value = personsOptions.value[0].value;

        showDate.value = result.showDate;
        datePlaceholderString.value = result.datePlaceholderString;
        disabledDates.value = result.disabledDates;
        minDate.value = result.minDate;
        maxDate.value = result.maxDate;

        loading.value = false;
      } catch (error: unknown) {
        console.log(error);
        errors.value.push(error.message);
      }

    }).catch((error) => {
        console.log(error);
        errors.value.push(error)
    });
}

const clearDatepicker = () => {
    date.value = null;
}

const showToday = computed(() => {
    let minimumDate = new Date(ISOStringToDate(minDate.value));
    let maximumDate = new Date(ISOStringToDate(maxDate.value));
    let isDisabled = false;

    disabledDates.value.map((date) => {
        dateToISOString(today).slice(0,10) === date ? isDisabled = true : null;
    })

    return (minimumDate <= today && maximumDate >= today) && !isDisabled;
});
const showTomorrow = computed(() => {
    let minimumDate = new Date(ISOStringToDate(minDate.value));
    let maximumDate = new Date(ISOStringToDate(maxDate.value));
    let isDisabled = false;

    disabledDates.value.map((date) => {
        dateToISOString(tomorrow).slice(0,10) === date ? isDisabled = true : null;
    })

    // radioTomorrow.value = (minimumDate <= tomorrow && maximumDate >= tomorrow) && !isDisabled;
    return (minimumDate <= tomorrow && maximumDate >= tomorrow) && !isDisabled;
});

watch(date , (newValue, oldValue) => {
    if(newValue !== null) {
        radioToday.value = false;
        radioTomorrow.value = false;
    }
});

const updatePrice = (value) => {
    selectedOption.value = value;
    personsOptions.value.map((person) => {
      if(person.value === value) {
        price.value = person.price;
        }
    });

}

watch(errors, (newValue, oldValue) => {
  if(newValue.length > 0) {
        hideQuickfinder.value = true;
    }
}, {deep: true});

const trackSubmit = () => {
  let trackingDate = today;

  if(radioTomorrow.value){
    trackingDate = tomorrow;
  }else if(date.value !== null && date.value !== undefined) {
    trackingDate = ISOStringToDate(date.value);
  }

  trackEvent('click_body_quickfinder',
     {
       category: ticketCategory.value,
       amount_people: selectedOption.value,
       date: showDate ? dateToISOString(trackingDate) : datePlaceholderString.value
     })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "ratio ratio-3x4",
            innerHTML: _ctx.img
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", { action: submitUrl.value }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(translate)('quickfinder.i.want')), 1),
                (_openBlock(), _createBlock(CustomSelect, {
                  label: _unref(translate)('quickfinder.category'),
                  labelClassName: "visually-hidden",
                  "class-name": "form-group--bold",
                  id: "category",
                  name: "category",
                  key: ticketCategoriesOptions.value,
                  onChangeValue: _cache[0] || (_cache[0] = ($event: any) => (changeTicketCategory($event))),
                  options: ticketCategoriesOptions.value
                }, null, 8, ["label", "options"]))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(translate)('quickfinder.for')), 1),
                (_openBlock(), _createBlock(CustomSelect, {
                  label: _unref(translate)('quickfinder.persons'),
                  labelClassName: "visually-hidden",
                  "class-name": "form-group--bold",
                  id: "persons",
                  name: "persons",
                  "selected-option": selectedOption.value,
                  key: personsOptions.value,
                  options: personsOptions.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updatePrice($event)))
                }, null, 8, ["label", "selected-option", "options"]))
              ]),
              (showDate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('quickfinder.for')), 1),
                    _createElementVNode("div", _hoisted_13, [
                      (showToday.value)
                        ? (_openBlock(), _createBlock(Radio, {
                            key: 0,
                            label: _unref(translate)('quickfinder.today'),
                            labelClassName: "mb-0",
                            "class-name": "form-group--bold",
                            id: "today",
                            name: "date",
                            checked: radioToday.value,
                            value: _unref(dateToISOString)(_unref(today)),
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => {radioToday.value = $event; clearDatepicker();})
                          }, null, 8, ["label", "checked", "value"]))
                        : _createCommentVNode("", true),
                      (showTomorrow.value)
                        ? (_openBlock(), _createBlock(Radio, {
                            key: 1,
                            label: _unref(translate)('quickfinder.tomorrow'),
                            labelClassName: "mb-0",
                            "class-name": "form-group--bold",
                            id: "tomorrow",
                            name: "date",
                            value: _unref(dateToISOString)(_unref(tomorrow)),
                            checked: radioTomorrow.value,
                            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => {radioTomorrow.value = $event; clearDatepicker();})
                          }, null, 8, ["label", "value", "checked"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (showToday.value && showTomorrow.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(translate)('quickfinder.or.on')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(), _createBlock(Datepicker, {
                        label: _unref(translate)('quickfinder.date.label'),
                        placeholder: _unref(translate)('quickfinder.date.label'),
                        "class-name": "form-group--bold quickfinder__datepicker",
                        id: "date",
                        name: "date",
                        "max-date": maxDate.value,
                        "min-date": minDate.value,
                        disable: disabledDates.value,
                        key: [disabledDates.value, minDate.value, maxDate.value, date.value].toString(),
                        "model-value": date.value,
                        disabled: datepickerDisabled.value,
                        "label-class-name": 'visually-hidden',
                        modelValue: date.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((date).value = $event))
                      }, null, 8, ["label", "placeholder", "max-date", "min-date", "disable", "model-value", "disabled", "modelValue"]))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('quickfinder.for')), 1),
                    _createElementVNode("strong", null, _toDisplayString(datePlaceholderString.value), 1)
                  ])),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", null, [
                    (price.value > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('quickfinder.dailyprice')), 1),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(Price, { value: price.value }, null, 8, ["value"])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(translate)('quickfinder.NoPriceFound')), 1))
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary btn-icon-text",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {radioToday.value || radioTomorrow.value ? datepickerDisabled.value = true : ''; trackSubmit();})
                  }, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('quickfinder.buy')), 1)
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_6)
        ])
      ])
    ], 512), [
      [_vShow, !hideQuickfinder.value]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("a", {
        href: _ctx.overviewUrl,
        class: "btn btn-primary"
      }, _toDisplayString(_unref(translate)('quickfinder.to-ticket-overview')), 9, _hoisted_22)
    ], 512), [
      [_vShow, hideQuickfinder.value]
    ]),
    _createVNode(Toast, {
      store: {errors: errors.value}
    }, null, 8, ["store"])
  ], 64))
}
}

})